import { getRequest } from '../../../../core/apiRequests';
import { getClientTags as getClientTagsService, getAllMerchantTags } from '../../../../services/clients';

export const clientDetailsEndpoints = [
  'getClientCollections',
  'getClientTags',
  'getClientAutoMessages',
  'getClientRecentActivity',
  'getClientReminders',
  'getClientSalesOpps',
  'getClientPurchases',
];

export const detailsRequestHandler = async (clientId, merchantId, endpoint, limit = 5) => {
  // Use unified API for getClientTags
  if (endpoint === 'getClientTags') {
    // Fetch both all merchant tags and tags assigned to this client
    const [allMerchantTags, clientAssignedTags] = await Promise.all([
      getAllMerchantTags({
        loadingStatusOff: true,
      }),
      getClientTagsService({
        clientId,
        query: { offset: 0, limit: 500 },
        loadingStatusOff: true,
      }),
    ]);

    // Create a Set of assigned tag IDs for fast lookup
    // Convert to numbers since client tags API returns string IDs while merchant tags API returns number IDs
    const assignedTagIds = new Set((clientAssignedTags || []).map(tag => Number(tag.id)));

    // Build the full tag list: all merchant tags with client_id set for assigned ones
    // Convert clientId to number to match the type from transformClientResponse (client.client_id)
    const numericClientId = Number(clientId);
    const tagsWithClientId = (allMerchantTags || []).map(tag => ({
      ...tag,
      // Set client_id for assigned tags, null for unassigned
      client_id: assignedTagIds.has(tag.id) ? numericClientId : null,
    }));

    return { details_tag_list: tagsWithClientId };
  }

  // Use legacy API for other endpoints
  const reqObj = {
    params: ['clients', merchantId, clientId, endpoint],
    query: { limit },
  };
  return await getRequest(reqObj);
};
